import { useEffect } from 'react';
import { AccountId, PermissionId, ProjectId } from 'api/models';
import { EventType, ProjectChannel, pushes, SocketData } from 'api/pushes';
import { useAccount } from './use-account';
import { useLatest } from './use-latest';
import { useUser } from './use-user';

export const useProjectWSUpdates = <T>(
  projectId: number,
  handler: (socketData: SocketData<T>) => void,
  [action, objectType]: EventType,
): void => {
  const userInfo = useUser();
  const { accountId } = useAccount();
  const permissionId =
    userInfo.permissions.projects[projectId]?.permissionSet.permissionSetId;
  const latestHandler = useLatest(handler);

  useEffect(() => {
    let subscription;

    if (permissionId) {
      const channel = ProjectChannel(
        AccountId(accountId),
        PermissionId(permissionId),
        ProjectId(projectId),
      );

      subscription = pushes<T>(channel, [action, objectType]).subscribe(
        latestHandler,
      );
    }

    return () => subscription && subscription.unsubscribe();
  }, [accountId, action, latestHandler, objectType, permissionId, projectId]);
};
